// extracted by mini-css-extract-plugin
export default {"ImageWrap":"ImageWrap_ImageWrap__y0Pkk","icon1":"ImageWrap_icon1__CJwRQ","container":"ImageWrap_container__zkPsd","number":"ImageWrap_number__gBNDa"};